import React from 'react';
import { HistoricOperationsStatusView } from '@fingo/lib/features/operations-status';
import CessionStatusOverlay from '../../../../features/factoring/components/overlays/CessionStatusOverlay';
import {
  getHistoricSummaryCards,
  DETAIL_SUMMARY_TABLE_COLUMNS,
} from '../../../../features/factoring/constants/operations-status';
import buildItauSteps from '../../../../features/factoring/helpers/invoiceTrackingSteps';

const HistoricOperationsStatus = () => (
  <HistoricOperationsStatusView
    getCards={getHistoricSummaryCards}
    summaryTableColumns={DETAIL_SUMMARY_TABLE_COLUMNS}
    getTrackingSteps={buildItauSteps}
    headerDescription="Aquí se encuentran las facturas históricas."
    useBorderedTitle
    OverlayComponent={CessionStatusOverlay}
    showRefreshButton
  />
);

export default HistoricOperationsStatus;
